import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PacerService } from '~/services/pacer';

const SKIP_URLS = [
  'UrlApi.json',
  'saveUrl',
  'removeUrl',
];

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private _pacer: PacerService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (SKIP_URLS.some(url => request.url.includes(url))) {
      return next.handle(request);
    }

    this._pacer.start(false, true);

    return next.handle(request).pipe(
      finalize(() => this._pacer.stop())
    );
  }
}
